import * as React from 'react';
require('./style.css');

interface IProps {
	title?: string;
	isLast?: boolean;
}

class SidebarBlock extends React.Component<IProps, {}> {
	public render() {
		const { children, title } = this.props;

		let titleContent = null;
		if (title && title.length > 0) {
			titleContent = <div className="blockLabel">{title}</div>;
		}

		return (
			<div className="sidebarBlock">
				{titleContent}
				{children}
			</div>
		);
	}
}
export { SidebarBlock };
